module.exports = __webpack_public_path__ + "img/46.5f78aa0a.png";